import { Button, ButtonLevel, ButtonSize } from '@vizit/atoms';
import { AlertCircleIcon } from '@vizit/icons';
import { Dialog, DialogHeaderStatus, DialogHeaderVariant } from '@vizit/molecules';
import { AVC_CONNECT_MODAL_COPY } from '../avc-connect-modal.constants';
import { AvcAuthErrorReason } from '../avc-connect-modal.types';
import { useAvcConnect } from '../provider/avc-connect.context';

const COPY = AVC_CONNECT_MODAL_COPY.error;

const NON_RETRYABLE_REASONS: readonly AvcAuthErrorReason[] = [
  AvcAuthErrorReason.OrgAdminRequired,
  AvcAuthErrorReason.RetailerRegionUnsupported,
];

function StepError() {
  const { errorReason, isRedirecting, close, startConnect } = useAvcConnect();
  const reason = errorReason ?? AvcAuthErrorReason.Unknown;
  const reasonCopy = COPY.reasons[reason];
  const canRetry = !NON_RETRYABLE_REASONS.includes(reason);

  return (
    <>
      <Dialog.Header variant={DialogHeaderVariant.Icon} status={DialogHeaderStatus.Error} icon={AlertCircleIcon}>
        <Dialog.Title>{COPY.title}</Dialog.Title>
        <Dialog.Subtitle>{reasonCopy}</Dialog.Subtitle>
      </Dialog.Header>

      <Dialog.Footer>
        <Button
          type="button"
          level={canRetry ? ButtonLevel.Secondary : ButtonLevel.Primary}
          size={ButtonSize.Lg}
          className="flex-1"
          onPress={close}
          isDisabled={isRedirecting}
        >
          {COPY.cancel}
        </Button>
        {canRetry && (
          <Button
            type="button"
            level={ButtonLevel.Primary}
            size={ButtonSize.Lg}
            className="flex-[2]"
            onPress={startConnect}
            isLoading={isRedirecting}
            data-testid="avc-connect-retry"
          >
            {COPY.retry}
          </Button>
        )}
      </Dialog.Footer>
    </>
  );
}

export { StepError };
